export function getEnvironmentId(): string {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) return "dev";
    if (hostname.includes("private.holopix.cn")) return "gray";
    if (hostname.includes("test.holopix.cn")) return "test";
    if (hostname.includes("holopix.cn")) return "prod";
  }
  return "unknown";
}

export function getCookieByName(name: string): string {
  if (typeof document === "undefined") return "";

  const prefix = `${encodeURIComponent(name)}=`;
  const cookie = document.cookie.split("; ").find((item) => item.startsWith(prefix));
  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : "";
}

export function getCookieConfig(): { domain: string; name: string } {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const envId = getEnvironmentId();

  if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
    return { domain: "", name: `token_${envId}` };
  }

  return { domain: ".holopix.cn", name: `token_${envId}` };
}

export function setTokenCookie(token: string): void {
  if (typeof document === "undefined") return;

  const { domain, name } = getCookieConfig();
  const settings = [
    `${encodeURIComponent(name)}=${encodeURIComponent(token)}`,
    "path=/",
    "expires=Thu, 01 Jan 2099 00:00:00 GMT",
    "SameSite=Lax",
    domain ? `domain=${domain}` : "",
    typeof window !== "undefined" && window.location.protocol === "https:" ? "Secure" : "",
  ].filter(Boolean);

  document.cookie = settings.join("; ");
}

export function deleteCookieByName(name: string, options?: { domain?: string }): void {
  if (typeof document === "undefined") return;

  const { domain: envDomain } = getCookieConfig();
  const domain = options?.domain ?? envDomain;
  const settings = [
    `${encodeURIComponent(name)}=`,
    "path=/",
    "max-age=0",
    "expires=Thu, 01 Jan 1970 00:00:00 GMT",
    "SameSite=Lax",
    domain ? `domain=${domain}` : "",
    typeof window !== "undefined" && window.location.protocol === "https:" ? "Secure" : "",
  ].filter(Boolean);

  document.cookie = settings.join("; ");
}

export function clearTokenCookie(): Promise<void> {
  const { name } = getCookieConfig();
  deleteCookieByName(name);
  if (name !== "token") {
    deleteCookieByName("token");
  }
  return Promise.resolve();
}

/**
 * 清除当前页面可访问的全部 cookie：对每个 cookie 名按「宿主域」「共享父域」两套 domain 各发一次过期指令。
 * 仅能清除非 HttpOnly 的 cookie（HttpOnly 的 JS 够不着，只能由后端过期）。
 * 用于 major 升级清站点数据——大版本不兼容，残留的旧 cookie（统计/风控/其他环境 token 等）可能携带
 * 与新版本冲突的脏状态，一律清掉；各 SDK（统计/神策等）会在后续页面加载时自动重建自己的 cookie。
 */
export function clearAllAccessibleCookies(): void {
  if (typeof document === "undefined") return;

  const { domain } = getCookieConfig();
  // 先收集名字再删除：document.cookie 会在删除过程中实时变化
  const names = document.cookie
    .split(";")
    .map((item) => item.split("=")[0]?.trim())
    .filter(Boolean);

  for (const name of names) {
    deleteCookieByName(name);
    deleteCookieByName(name, { domain });
  }
}
